























































































































import Vue from 'vue';
import util from '@/utils';
import key from '@/libs/filters/key';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { TLeadsDetailForm, TLeadsRemark } from '@/types/views/school';
import { getLeadsRemark, updateLeads } from '@/api/school';
@Component({})
export default class Info extends Vue {
  @Prop({
    type: Object,
    default() {
      return {};
    }
  })
  info!: TLeadsDetailForm;

  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  getData!: Function;
  @Watch('info')
  watchInfo(info: TLeadsDetailForm) {
    if (!info) return;
    this.setForm(info);
    this.getRemarksById();
  }
  private remarks: TLeadsRemark[] = [];
  private key: any = key;
  private loading = false;
  private form: TLeadsDetailForm = {
    id: 0,
    phone: '',
    childName: '',
    age: 0,
    sex: '',
    grade: '',
    school: '',
    name: '',
    parentName: '',
    intention: '',
    nextComm: '',
    startTime: '',
    dataStatus: '',
    content: '',
    userName: ''
  };
  private async getRemarksById() {
    try {
      let res: any = await getLeadsRemark({ id: this.info.id });
      this.remarks = res;
    } catch (e) {
      this.$message.error(e.message);
    }
  }
  private setForm(form: TLeadsDetailForm) {
    let f: any = { ...form };
    this.form = {
      id: f.id,
      age: f.age,
      childName: f.realname,
      content: f.content,
      dataStatus: f.dataStatus,
      grade: f.userGrade,
      intention: f.intention,
      nextComm: f.nextComm,
      parentName: f.mothername,
      phone: f.phone,
      school: f.school,
      sex: f.sex,
      userName: f.userName
    };
  }
  private async onSubmit() {
    let f = { ...this.form };
    let opts = {
      id: f.id,
      age: f.age,
      childName: f.childName,
      content: f.content,
      dataStatus: f.dataStatus,
      grade: f.grade,
      intention: f.intention,
      nextComm: util.toDate(f.nextComm) || '',
      parentName: f.parentName,
      phone: f.phone,
      school: f.school,
      sex: f.sex,
      userName: f.userName
    };
    this.loading = true;

    try {
      await updateLeads(opts);
      this.form.content = '';
      this.getData();
      this.$message.success('Leads信息更新成功');
    } catch (err) {
      this.$message.error(err.message);
    } finally {
      this.loading = false;
    }
  }
}
